export default __webpack_public_path__ + "static/pp-reciclare-205df81079668bdfe4c9de398446e726.jpg";